import { render, staticRenderFns } from "./Wizard.vue?vue&type=template&id=50f61132&scoped=true&"
import script from "./Wizard.vue?vue&type=script&lang=js&"
export * from "./Wizard.vue?vue&type=script&lang=js&"
import style0 from "./Wizard.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Wizard.vue?vue&type=style&index=1&id=50f61132&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f61132",
  null
  
)

export default component.exports